module.exports = __webpack_public_path__ + "img/a3.8ed2c58f.jpg";